import React from 'react';

import Column from '@sdk/components/ui/spacing/Column';

import { Layout } from '../components/Layout';
import { SideImg } from './LayoutWithImage.styles';

type Props = {
  children: JSX.Element;
  image: JSX.Element;
};

export const LayoutWithImage = ({ children, image }: Props) => (
  <Layout>
    <SideImg>{image}</SideImg>
    <Column>{children}</Column>
  </Layout>
);
